import { fmtFull } from "../../shared/format.js";
import { Sheet } from "./Sheet.js";
import type { GuestEvent } from "./guest.api.js";

export function DetailsSheet({
  open,
  onClose,
  data,
}: {
  open: boolean;
  onClose: () => void;
  data: GuestEvent;
}) {
  return (
    <Sheet open={open} onClose={onClose} title={data.event.name}>
      <div className="flex flex-col gap-3 text-center">
        <p className="font-serif text-xl text-stone-900">
          {data.wedding.partner1Name} &amp; {data.wedding.partner2Name}
        </p>
        <p className="text-sm text-stone-500">
          {fmtFull(data.event.date)}
          {data.event.location ? ` · ${data.event.location}` : ""}
        </p>
        {data.wedding.story && (
          <p className="mt-2 font-serif italic text-stone-700">« {data.wedding.story} »</p>
        )}
      </div>
    </Sheet>
  );
}
